import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import OrderService from "../Services/OrderService";

export const getList = (store, value, prevTabActive, tabStatus) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  const refresh = !prevTabActive;
  store.setState({ isLoading, status, refresh });
  return OrderService.getList(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;

      store.state.data = prevTabActive ? store.state.data.concat(data) : data;

      if (data.length === 0) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
        refresh: false,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getListTransaction = (store, value, prevTabActive, tabStatus) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  const refresh = !prevTabActive;
  store.setState({ isLoading, status, refresh });
  OrderService.getListTransaction(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;

      store.state.data = prevTabActive ? store.state.data.concat(data) : data;

      if (data.length === 0) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
        refresh: false,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const patch = async (store, id, params) => {
  try {
    const response = await OrderService.patchData(id, params);
    const data = response.data;
    notifUtils("Successfully Update Order", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const patchTransaction = async (store, id, params) => {
  try {
    const response = await OrderService.patchTransactionData(id, params)
    const data = response.data;
    notifUtils("Successfully Update Transaction", "success");
    return data;
  } catch (error) {
    handleError(error)
    return error
  }
}
